import { render, staticRenderFns } from "./LayoutAccentCard.vue?vue&type=template&id=ef86aa8a&scoped=true&"
import script from "./LayoutAccentCard.vue?vue&type=script&lang=js&"
export * from "./LayoutAccentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef86aa8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
